module.exports = __webpack_public_path__ + "orcascan-logo-6681552843ac711f1fe066793d4e0670.webp";